module.exports = __webpack_public_path__ + "static/media/lightningGamesPlayed_250_500.4d0bbe37.png";